import { useEffect, useRef, useState } from "react";

export type SizeUnit = string | number;

export const pixelateSizeUnit = (size: SizeUnit) =>
  typeof size === "number" ? size + "px" : size;

/**
 * Requires toast container to have class .hermes-toast-container
 */
export const isToast = (element: Element) => {
  return element.closest(".hermes-toast-container") !== null;
};

export function useElementWidth<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState<number | null>(null);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver(([entry]) => {
      if (entry) setWidth(entry.contentRect.width);
    });

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return { ref, width };
}
